<tt-page>
    <tt-card [class]="tabletSize.matches ? 'col-xs-12 col-md-4 p-5' : 'col-xs-12 sp-0'">
        <tt-page-heading *ngIf="tabletSize.matches" ttModel="h_info" ttTranslate></tt-page-heading>
        <tt-radio-button-group *ngIf="!tabletSize.matches" [ttModel]="selectedTab" (ttModelChange)="selectTab($event)">
            <tt-radio-button ttValue="workhours" ttLabel="workhours"></tt-radio-button>
            <tt-radio-button ttValue="break" ttLabel="break"></tt-radio-button>
        </tt-radio-button-group>
        <tt-input ttLabel="shift_id" [ttModel]="params.shift_id" ttReadonly></tt-input>
        <tt-input ttLabel="dayname" [ttModel]="dayName" ttReadonly></tt-input>
    </tt-card>
    <tt-card *ngIf="tabletSize.matches || selectedTab === 'workhours'" [class]="tabletSize.matches ? 'col-xs-12 col-md-4 p-5' : 'col-xs-12 sp-0'">
        <tt-page-heading *ngIf="tabletSize.matches" ttModel="workhours" ttTranslate></tt-page-heading>
        <tt-input ttLabel="time_used" [ttModel]="timeUsed" ttReadonly></tt-input>
        <tt-list [ttData]="hours"></tt-list>
        <tt-button ttText="create_new_shift_time" ttIcon="fas fa-plus" ttTextAlign="left" ttIconPullRight ttGoto="shiftdaytime" [ttGotoParms]="{ shifttime_keyno: '0', shift_id: params.shift_id, dayno: params.dayno }"></tt-button>
    </tt-card>
    <tt-card *ngIf="tabletSize.matches || selectedTab === 'break'" [class]="tabletSize.matches ? 'col-xs-12 col-md-4 p-5' : 'col-xs-12 sp-0'">
        <tt-page-heading *ngIf="tabletSize.matches" ttModel="break" ttTranslate></tt-page-heading>
        <tt-list [ttData]="breaks"></tt-list>
        <tt-button ttText="create_new_shift_break" ttIcon="fas fa-plus" ttTextAlign="left" ttIconPullRight ttGoto="shiftdaybreak" [ttGotoParms]="{ shiftbreak_keyno: '0', shift_id: params.shift_id, dayno: params.dayno }"></tt-button>
    </tt-card>
</tt-page>
